import { Button as MuiButton } from "@mui/material";
import { Button, Dialog } from "@platform/design-system";

interface UnsavedChangesDialogProps {
  open: boolean;
  onDiscard: () => void;
  onCancel: () => void;
  onSave: () => void;
  isSaving: boolean;
}

const UnsavedChangesDialog = ({
  open,
  onDiscard,
  onCancel,
  onSave,
  isSaving,
}: UnsavedChangesDialogProps): React.JSX.Element => (
  <Dialog
    open={open}
    onClose={onCancel}
    title="Unsaved changes"
    actions={
      <>
        <MuiButton
          variant="text"
          color="error"
          onClick={onDiscard}
          disabled={isSaving}
        >
          Discard
        </MuiButton>
        <Button variant="secondary" onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave} loading={isSaving}>
          Save
        </Button>
      </>
    }
  >
    You have unsaved changes.
  </Dialog>
);

export default UnsavedChangesDialog;
